// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_dedicatedTimeFeedContainer__VQDBC {
  display: flex;
  flex-direction: column;
  max-height: 72vh;
  overflow-y: scroll; }
  .styles_dedicatedTimeFeedContainer__VQDBC > div {
    min-height: 18rem;
    max-height: 36rem;
    margin: 0.5rem 1rem; }
  .styles_dedicatedTimeFeedContainer__VQDBC > button {
    height: 18rem;
    margin: 0.5rem 0.5rem; }

.styles_mappedTimeContainer__hIcpy {
  min-height: 54vh;
  overflow-y: scroll; }
  .styles_mappedTimeContainer__hIcpy > div {
    min-height: 54vh;
    max-height: 72vh;
    margin: 0.5rem 1rem; }
    .styles_mappedTimeContainer__hIcpy > div > div {
      height: -webkit-fill-available;
      width: 100%; }

.styles_searchComponent__UWIbJ {
  width: 100%;
  width: 100%;
  max-height: 90%;
  padding: 0.125rem 1rem;
  height: 2.5rem;
  border-radius: 0.5rem; }
  .styles_searchComponent__UWIbJ input {
    padding: 0.125rem 1rem;
    height: 100%;
    height: 2.5rem; }

.styles_cyclesCard__C8n8O {
  height: -webkit-fill-available;
  overflow-y: scroll; }
`, "",{"version":3,"sources":["webpack://./src/modules/booths/components/screens/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB,EAAA;EAJtB;IAOQ,iBAAiB;IACjB,iBAAiB;IACjB,mBACJ,EAAA;EAVJ;IAaQ,aAAa;IAEb,qBACJ,EAAA;;AAGJ;EACI,gBAAgB;EAChB,kBAAkB,EAAA;EAFtB;IAIQ,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB,EAAA;IAN3B;MAQY,8BAA8B;MAC9B,WAAW,EAAA;;AAKvB;EACI,WAAW;EACX,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,qBAAqB,EAAA;EANzB;IASQ,sBAAsB;IACtB,YAAY;IACZ,cAAc,EAAA;;AAItB;EACI,8BAA8B;EAC9B,kBAAkB,EAAA","sourcesContent":[".dedicatedTimeFeedContainer {\n    display: flex;\n    flex-direction: column;\n    max-height: 72vh;\n    overflow-y: scroll;\n\n    &>div {\n        min-height: 18rem;\n        max-height: 36rem;\n        margin: 0.5rem 1rem\n    }\n\n    & > button {\n        height: 18rem;\n        // width: -webkit-fill-available;\n        margin: 0.5rem 0.5rem\n    }\n}\n\n.mappedTimeContainer {\n    min-height: 54vh;\n    overflow-y: scroll;\n    & > div {\n        min-height: 54vh;\n        max-height: 72vh;\n        margin: 0.5rem 1rem;\n        & > div {\n            height: -webkit-fill-available;\n            width: 100%;\n        }\n    }\n}\n\n.searchComponent {\n    width: 100%;\n    width: 100%;\n    max-height: 90%;\n    padding: 0.125rem 1rem;\n    height: 2.5rem;\n    border-radius: 0.5rem;\n\n    input {\n        padding: 0.125rem 1rem;\n        height: 100%;\n        height: 2.5rem;\n    }\n}\n\n.cyclesCard {\n    height: -webkit-fill-available;\n    overflow-y: scroll;\n}\n\n.cyclesCard>div {\n    // border: 3px solid blue;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dedicatedTimeFeedContainer": `styles_dedicatedTimeFeedContainer__VQDBC`,
	"mappedTimeContainer": `styles_mappedTimeContainer__hIcpy`,
	"searchComponent": `styles_searchComponent__UWIbJ`,
	"cyclesCard": `styles_cyclesCard__C8n8O`
};
export default ___CSS_LOADER_EXPORT___;
